<template>
  <div class="PersonVacationListWeb">
    <v-data-table
      dense
      :disable-sort="false"
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 50, 100, -1],
        'items-per-page-text': $t('rowsPerPage'),
        'show-first-last-page': true,
      }"
      @click:row="handleClick"
    >
      <template v-slot:header.select="{}">
        <v-checkbox
          dense
          hide-details="true"
          v-model="isCheckAll"
          @change="checkAll()"
        ></v-checkbox>
      </template>
      <template v-slot:item.select="{ item }">
        <v-checkbox
          dense
          hide-details="true"
          v-model="item.select"
          @click.stop=""
        ></v-checkbox>
      </template>

      <template v-slot:item.ClockName="{ item }">
        <span v-if="item.ClockName.trim()">{{ item.ClockName.trim() }}</span>
        <span v-else>ثبت توسط کاربر</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      isCheckAll: false,
      selectedList: [],
      headers: [
        {
          text: this.$t("card-no"),
          value: "Perno",
        },
        {
          text: this.$t("person-name"),
          value: "PersonName",
        },
        {
          text: this.$t("date"),
          value: "ClockDate",
        },
        {
          text: this.$t("time"),
          value: "ClockTime",
        },
        {
          text: this.$t("io"),
          value: "Io",
        },
        {
          text: this.$t("systemName"),
          value: "ClockName",
        },
        {
          text: this.$t("RequestDate"),
          value: "RequestDate",
        },
        {
          text: this.$t("status"),
          value: "StatusType",
        },
        {
          text: this.$t(""),
          value: "select",
        },
      ],
    };
  },
  methods: {
    checkAll() {
      var list = [...this.list];
      if (this.isCheckAll) {
        list.forEach((element) => {
          element.select = true;
        });
      } else {
        list.forEach((element) => {
          element.select = false;
        });
      }

      this.list = list;
    },
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style>
</style>